<template>
  <div id="general-search">
    <v-container fluid class="content-wrapper px-4 px-md-8">
      <v-tabs v-model="tab" show-arrows active-class="primary200--text">
        <v-tabs-slider color="primary200"></v-tabs-slider>
        <v-tab>{{ 'Services (' + resourcesLength + ')' }}</v-tab>
        <v-tab @click="goToGeneralSearchProvider">{{
          'Providers (' + providersLength + ')'
        }}</v-tab>
      </v-tabs>
      <v-tabs-items v-model="tab" class="pa-6">
        <v-tab-item :transition="false" :reverse-transition="false" eager :key="1">
          <marketplace-services-component
            :show-sort-by="true"
            @resourcesLength="length => (resourcesLength = length)"
          ></marketplace-services-component>
        </v-tab-item>
      </v-tabs-items>
    </v-container>
  </div>
</template>

<script>
import MarketplaceServicesComponent from '@/components/marketplace/MarketplaceResourcesComponent';

export default {
  name: 'MarketplaceGeneralSearch',
  components: { MarketplaceServicesComponent },
  data() {
    return {
      tab: 0,
      resourcesLength: '-',
      providersLength: '-',
      text: null,
    };
  },
  created() {
    this.text = this.$route.query.text;
    let url = '/api/v1/providers?';
    if (this.text) {
      url += 'text=' + this.text;
    }
    this.axios.get(url).then(res => {
      this.providersLength = res.data.total;
    });
  },
  methods: {
    goToGeneralSearchProvider() {
      console.log('goToGeneralSearchProvider');
      let path = 'MarketplaceGeneralSearchProvider';
      if (!this.$router.currentRoute.meta.requiresAuth) {
        path = 'PublicMarketplaceGeneralSearchProvider';
      }
      this.$router
        .push({
          name: path,
          query: { text: this.text },
        })
        .catch(err => {
          throw new Error(`Problem handling something: ${err}.`);
        });
    },
  },
};
</script>
